import React from "react";
import { NavigationIdType } from "./stores/AlarmIndicatorSlice";
import { useBoundStore } from "./useBoundStore";

export const useAlarmIndicatorStore = () => {
  const activeAlarmIndicators = useBoundStore(
    (state) => state.alarmIndicatorObject,
  );

  const updateAlarm = useBoundStore((state) => state.updateAlarm);

  const hasAlarm = React.useCallback(
    (alarmKey: NavigationIdType) =>
      Object.keys(activeAlarmIndicators).includes(alarmKey),
    [activeAlarmIndicators],
  );

  const getAlarmIndicator = React.useCallback(
    (alarmKey: NavigationIdType) => activeAlarmIndicators[alarmKey],
    [activeAlarmIndicators],
  );

  return { activeAlarmIndicators, updateAlarm, hasAlarm, getAlarmIndicator };
};
